import { Transacao } from '../../../servicos/transacoes/typeTransacao';
import { ehSaldoInicial } from '../../../utils/Utils';

/**
 * Movimentação do mês por conta (receitas − despesas das transações vinculadas
 * à conta) — extraída da tela de Contas sem mudança de comportamento.
 *
 * REGRAS: pagamento de fatura e transferência CONTAM aqui — é caixa entrando/
 * saindo da conta de verdade. Saldo inicial NÃO conta: é configuração (entra
 * só no saldo consolidado, que o backend calcula).
 */
export const movimentoPorConta = (transacoes: Transacao[]): Map<number, number> => {
  const mapa = new Map<number, number>();
  transacoes.forEach((transacao) => {
    if (!transacao.contaId || ehSaldoInicial(transacao)) return;
    const delta = transacao.tipo === 'R' ? transacao.valor : -transacao.valor;
    mapa.set(transacao.contaId, (mapa.get(transacao.contaId) || 0) + delta);
  });
  return mapa;
};
